import React from "react";
import DeleteIcon from "material-ui-icons/Delete";
import { IconButton, withStyles } from "material-ui";

const styles = () => ({
  deleteButton: {
    width: 34,
    height: 34,
    padding: 6,
    borderRadius: 9,
    color: "#dc2626",
    backgroundColor: "#fef2f2",
    transition: "all 0.18s ease",
    "&:hover": {
      backgroundColor: "#fee2e2",
      color: "#b91c1c"
    }
  },

  deleteIcon: {
    fontSize: 19
  }
});

const DeleteButton = ({ onDelete, classes }) => (
  <IconButton
    className={classes.deleteButton}
    onClick={() => onDelete()}
    title="Delete"
  >
    <DeleteIcon className={classes.deleteIcon} />
  </IconButton>
);

export default withStyles(styles)(DeleteButton);
